import * as React from 'react'

import { Dialog } from '@material-ui/core'

import { DefaultLoader } from './DefaultLoader'

import './style.scss'

interface INativeProps {
  children?: React.ReactNode
  loading: boolean
  text?: string
}

interface IProps extends INativeProps {}
interface IState {}

export class Loader extends React.Component<IProps, IState> {
  getChild = () => {
    const { children, text } = this.props
    return children || <DefaultLoader text={text} />
  }

  render() {
    const { loading } = this.props
    return (
      <Dialog open={loading} className="fullscreen-loader" fullScreen={true}>
        {this.getChild()}
      </Dialog>
    )
  }
}

export * from './DefaultLoader'



// WEBPACK FOOTER //
// ./src/components/Loader/index.tsx